import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=8d6b0984"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d6b0984')) {
      api.createRecord('8d6b0984', component.options)
    } else {
      api.reload('8d6b0984', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=8d6b0984", function () {
      api.rerender('8d6b0984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/dialog/Default.vue"
export default component.exports